import { fetch } from '../request'
import type {
  IResponse,
  RequestConfig,
  ScenariosData,
  ScenariosDetailRequest,
} from '../interface'

export const getScenariosDetail = (
  params: ScenariosDetailRequest,
  config?: RequestConfig
) =>
  fetch<IResponse<ScenariosData[]>>('/promotion_center/application_scene/', {
    method: 'GET',
    query: params,
    ...config,
  })
